import { Stack, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';

/**
 * Standard section header for marketing pages.
 *
 * @param {object} props
 * @param {string} props.titleKey - i18n key for the section title
 * @param {string} [props.descriptionKey] - i18n key for lead paragraph
 * @param {'center' | 'left'} [props.align]
 */
export function MarketingSection({ titleKey, descriptionKey, align = 'center' }) {
  const { t } = useTranslation('common');

  return (
    <Stack gap="sm" align={align === 'center' ? 'center' : 'flex-start'} mb="xl">
      <Title order={2} ta={align}>
        {t(titleKey)}
      </Title>
      {descriptionKey && (
        <Text c="dimmed" ta={align} maw={640}>
          {t(descriptionKey)}
        </Text>
      )}
    </Stack>
  );
}
